<template>
    <font-awesome-icon :icon="[Starred, 'star']" />
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name: 'Star',
    components: {},
    props: {
        starred: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        Starred() {
            return this.starred ? 'fas' : 'far';
        }
    }
})
export default class Star extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
